import React, { useEffect, useRef } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { Loader } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../redux/hooks';
import { selectNavigationPaths } from '../../../redux/slices/layout';

/**
 * Check if the hardcoded route exists in the navigation-items endpoint.
 * If it doesn´t exist, it navigates to the default route.
 */
function PrivateNavigationAccessRoute() {
  const location = useLocation();
  const { t } = useTranslation();
  const navigationItemsPaths = useAppSelector(selectNavigationPaths);
  const openedRef = useRef(false);

  const fallbackNavItem =
    navigationItemsPaths &&
    navigationItemsPaths.length > 0 &&
    !navigationItemsPaths.some((item) => item.to === location.pathname)
      ? navigationItemsPaths[0]
      : undefined;

  useEffect(() => {
    if (fallbackNavItem?.target === '_blank' && !openedRef.current) {
      openedRef.current = true;
      window.open(fallbackNavItem.to, fallbackNavItem.target, 'noopener,noreferrer');
    }
  }, [fallbackNavItem]);

  if (navigationItemsPaths && navigationItemsPaths.some((item) => item.to === location.pathname)) {
    return <Outlet />;
  } else if (fallbackNavItem) {
    if (fallbackNavItem.target === '_blank') {
      return (
        <p className="text-center">
          {t('opened-in-new-tab')}
          <br />
          <a href={fallbackNavItem.to} target="_blank" rel="noopener noreferrer">
            {t('click-here-if-not-redirected')}
          </a>
        </p>
      );
    }
    return <Navigate to={fallbackNavItem.to} />;
  } else {
    return <Loader title={t('loading-data')} />;
  }
}

export default PrivateNavigationAccessRoute;
